/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum EquipmentLocateOperationStatuses {

    PendingDispatch = 'PendingDispatch',

    Dispatched = 'Dispatched',

    DeviceRequestSent = 'DeviceRequestSent',

    TelemetryConfirmed = 'TelemetryConfirmed',

    Failed = 'Failed',

    Stale = 'Stale',

    Superseded = 'Superseded'
}

